import { Controller } from "@hotwired/stimulus"

// A narrated outcome's value lens (NarrationHelper#narration_table_html): a
// value read from the paperwork opens, under its table, the extracted line it
// came from. One open at a time; a second click closes it. In the page's flow,
// so it never hangs off the column or under the table's scroll edge.
export default class extends Controller {
  static targets = ["panel"]

  toggle(event) {
    const button = event.currentTarget
    const panel = this.panelTargets.find((candidate) => candidate.id === button.dataset.lens)
    if (!panel) return
    const opening = panel.hidden
    this.panelTargets.forEach((candidate) => { candidate.hidden = true })
    this.element.querySelectorAll("[data-lens]").forEach((value) => value.setAttribute("aria-expanded", "false"))
    panel.hidden = !opening
    button.setAttribute("aria-expanded", String(opening))
  }
}
